import React from "react";
import { Icon } from "antd";

export default function MaterialRequestLoadingModal() {
  return (
    <div className="MaterialRequestLoadingModal">
      <div className="modal-overlay">
        <div className="modal-container">
          <div className="loading-message-container">
            <span>
              <b>Cargando...</b>
            </span>
          </div>

          <div className="spinner-container">
            <Icon type="sync" spin />
          </div>
        </div>
      </div>
    </div>
  );
}
